import { MATERIAL_SYMBOLS_SUBSET_FONT_FAMILY } from '@famly/mf_theme';
/**
 * Registers the subset of the Material Symbols font that holds the icons the code names, a fraction
 * of the full font. Like an `@font-face` rule, it downloads only once something renders in it.
 * Until an app registers it, the theme's font stack falls through to the full font for every icon.
 */
export const registerMaterialSymbolsSubset = (url) => {
    if (typeof FontFace === 'undefined' || typeof document === 'undefined' || !document.fonts) {
        return;
    }
    document.fonts.add(new FontFace(MATERIAL_SYMBOLS_SUBSET_FONT_FAMILY, `url(${url}) format('woff2')`));
};
